import { orm } from 'smartmenu/models';
import { createSelector } from 'redux-orm';

export const all = createSelector(orm, session => {
  return session.SalesChannel.all().toRefArray();
});
